const GlobalContextInitial = {
  mode: localStorage.getItem('theme') || 'light',
  toggle: () => null
};

export default GlobalContextInitial;
